import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLocker = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.75 3.75h-1.5V2.625a2.25 2.25 0 1 0-4.5 0V3.75h-1.5a.75.75 0 0 0-.75.75v5.25a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.75M6.375 7.436v1.189a.375.375 0 0 1-.75 0v-1.19a1.125 1.125 0 1 1 .75 0M7.5 3.75h-3V2.625a1.5 1.5 0 0 1 3 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLocker);
export default ForwardRef;
